import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=bcb4818c&scoped=true"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"
import style0 from "./GenericList.vue?vue&type=style&index=0&id=bcb4818c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4818c",
  null
  
)

export default component.exports